import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store/store';

export enum StudyPhase {
  HOME = 'home',
  BLOCK_SELECT = 'blockSelect',
  BLOCK_STUDY = 'blockStudy',
  BLOCK_REVIEW = 'blockReview',
  FLASHCARD_STUDY = 'flashcardStudy',
  SESSION_SUMMARY = 'sessionSummary',
  PAST_BLOCKS = 'pastBlocks',
  LOADING_BLOCK_STUDY = 'loadingBlockStudy',
  LOADING_BLOCK_REVIEW = 'loadingBlockReview',
  LOADING_BLOCK_SELECT = 'loadingBlockSelect',
  LOADING_FLASHCARD_STUDY = 'loadingFlashcardStudy',
  LOADING_SESSION_SUMMARY = 'loadingSessionSummary',
  LOADING_PAST_BLOCKS = 'loadingPastBlocks',
  LOADING_HOME = 'loadingHome',
  VIDEO_STUDY = 'videoStudy',
  LOADING_VIDEO_STUDY = 'loadingVideoStudy',
}

// Simple helper functions if needed
export const isLoadingPhase = (phase: StudyPhase): boolean =>
  phase.startsWith('loading');

interface StudyState {
  phase: StudyPhase;
  activeQuestionIndex: number;
}

const initialState: StudyState = {
  phase: StudyPhase.HOME,
  activeQuestionIndex: 0,
};

const studySlice = createSlice({
  name: 'studyPhase',
  initialState,
  reducers: {
    setStudyPhase(state, action: PayloadAction<StudyPhase>) {
      state.phase = action.payload;
    },
    setActiveQuestionIndex(state, action: PayloadAction<number>) {
      state.activeQuestionIndex = action.payload;
    },
  },
});

export const selectStudyPhase = (state: RootState) => state.studyPhase.phase;
export const selectActiveQuestionIndex = (state: RootState) =>
  state.studyPhase.activeQuestionIndex;

export const { setStudyPhase, setActiveQuestionIndex } = studySlice.actions;
export default studySlice.reducer;
